<template lang="html">
  <div class="wrapper margin-menu">
    <section class="intro column-center -civsem">
      <h2>Centro de Investigación en Valores</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.civsem')">CIVSEM</router-link>
      </nav>
    </section>

    <main>
      <div class="container">
        <h2 class="title-intro">
          <img src="/static/img/civsem-completo.png" alt="Logo CIVSEM" />
        </h2>
      </div>

      <section class="white-box objetivo-civsem">
        <div class="container row-start">
          <h2 class="big-title">Objetivo</h2>
          <h3 class="title-intro">Actividad <strong>Social</strong></h3>
        </div>
        <p class="texto-intro">
          Su fin es la investigación, divulgación y formación sobre Valores
          Humanos y cómo estos favorecen la integración, convivencia,
          superación, innovación y sentido de trascendencia de las personas.
        </p>

        <div class="contenedor-dpop container row-start ais">
          <div class="texto column-center">
            <h2>DPOP</h2>
            <p>
              Programa de formación y coaching para identficar y poner en valor
              el talento de cada uno.
            </p>
            <p>
              Para reinventarse y construir una vida de la que se sientan
              orgullosos.
            </p>
          </div>
          <div class="imagen">
            <img
              src="/static/img/imagen-dpop.jpg"
              class="imagen-grupo"
              alt="DPOP"
            />
          
          </div>
        </div>
      </section>

      <section class="banner-fondo-civsem">
        <p>
          Si quieres más información sobre el proyecto puedes visitar nuestra
          web.
        </p>
        <a href="http://civsem.com" target="_blank" class="btn with-border"
          >Ir a la web</a
        >
      </section>

    </main>
  </div>
</template>

<script lang="js">


import Slick from 'vue-slick';


  export default {
    name: 'civsem',
    components: { Slick },
    data() {
        return {
            slickOptions: {
                slidesToShow: 1
            },
        };
    },
  }
</script>
<style lang="scss" scoped>
@import "@/assets/css/colors.scss";
.texto-intro {
  margin-top: 30px;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/civsem.vue